import { render, staticRenderFns } from "./CustomerEditorModals.vue?vue&type=template&id=01d3df7f&scoped=true&"
import script from "./CustomerEditorModals.vue?vue&type=script&lang=js&"
export * from "./CustomerEditorModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d3df7f",
  null
  
)

export default component.exports